// eslint-disable-next-line no-shadow
export enum returnSendEmailRecoveryPasswordErrorType {
  errorTimesRecovery= 'COD_ERROR_TIMES_RECOVERY',
  errorNotExist= 'COD_ERROR_NOT_EXIST',
  errorAttempts= 'COD_ERROR_ATTEMPTS',
  errorOperator= 'COD_ERROR_OPERATOR',
  errorSentRecently= 'COD_ERROR_EMAIL_SENT_RECENTLY',
  errorSentExceeded= 'COD_ERROR_EMAIL_SENT_EXCEEDED_TIMES'
}

